import React, { useState } from "react";
import {
  FiLogOut,
  FiEdit2,
  FiLock,
  FiMail,
  FiPhone,
  FiCheckCircle,
  FiCalendar,
  FiUser,
} from "react-icons/fi";
import userPic from "../assets/user.png";
import useAuth from "../useAuth";
import EditProfileModal from "../Components/EditProfileModal";
import ChangePasswordModal from "../Components/ChangePasswordModal";

export const ProfilePage = () => {
  const { user, logout } = useAuth();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  // Mock handlers for now
  const handleEditProfile = (updatedData) => {
    console.log("Updated Profile Data:", updatedData);
    // Here you would typically call an API to update the user profile
    setIsEditModalOpen(false);
  };

  const handleChangePassword = (passwordData) => {
    console.log("Password Change Data:", passwordData);
    // Here you would typically call an API to change the password
    setIsPasswordModalOpen(false);
  };

  const handleLogout = () => {
    let userRes = window.confirm("Are you sure, You want to logout?");

    if (userRes) {
      logout();
    } else return null;
  };

  return (
    <div className="min-h-screen bg-gray-50/50 py-12 px-4 sm:px-6 lg:px-8 mt-10">
      <div className="max-w-4xl mx-auto">
        {/* Profile Header Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-6 transition-all hover:shadow-2xl">
          <div className="h-32 bg-gradient-to-r from-blue-600 to-indigo-700 relative">
            <div className="absolute -bottom-12 left-8">
              <div className="relative">
                <img
                  src={user?.profilePhoto || userPic}
                  alt="Profile"
                  className="w-24 h-24 rounded-full border-4 border-white shadow-lg object-cover bg-white"
                />
                <div
                  className="absolute bottom-1 right-1 w-5 h-5 bg-green-500 border-2 border-white rounded-full"
                  title="Online"
                ></div>
              </div>
            </div>
          </div>

          <div className="pt-16 pb-8 px-8">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <div>
                <h1 className="text-3xl font-bold text-gray-900">
                  {user?.name || "User Name"}
                </h1>
                <p className="text-blue-600 font-medium mt-1 flex items-center gap-2">
                  <span className="bg-blue-50 px-3 py-1 rounded-full text-sm border border-blue-100">
                    {user?.designation || "Designation"}
                  </span>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-500 text-sm uppercase tracking-wide">
                    {user?.userType || "User Type"}
                  </span>
                </p>
              </div>

              <div className="flex gap-3 w-full sm:w-auto">
                <button
                  className="disabled:bg-gray-200 disabled:hover:bg-none disabled:cursor-no-drop flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all shadow-sm font-medium"
                  onClick={() => setIsEditModalOpen(true)}
                  disabled
                >
                  <FiEdit2 size={16} />
                  Edit Profile
                </button>
                <button
                  className="disabled:bg-gray-200 disabled:hover:bg-none disabled:cursor-no-drop flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all shadow-sm font-medium"
                  onClick={() => setIsPasswordModalOpen(true)}
                  disabled
                >
                  <FiLock size={16} />
                  Security
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Contact Information */}
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
              <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                <span className="p-2 bg-blue-100 text-blue-600 rounded-lg">
                  <FiUser size={20} />
                </span>
                Personal Information
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-1">
                  <label className="text-sm font-medium text-gray-500 flex items-center gap-2">
                    <FiMail size={14} /> Email Address
                  </label>
                  <p className="text-gray-900 font-medium break-all">
                    {user?.email || "email@example.com"}
                  </p>
                </div>

                <div className="space-y-1">
                  <label className="text-sm font-medium text-gray-500 flex items-center gap-2">
                    <FiPhone size={14} /> Mobile Number
                  </label>
                  <p className="text-gray-900 font-medium">
                    {user?.mobile || "+91 XXXXX XXXXX"}
                  </p>
                </div>

                <div className="space-y-1">
                  <label className="text-sm font-medium text-gray-500 flex items-center gap-2">
                    <FiCheckCircle size={14} /> Account Status
                  </label>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Verified Account
                  </span>
                </div>

                <div className="space-y-1">
                  <label className="text-sm font-medium text-gray-500 flex items-center gap-2">
                    <FiCalendar size={14} /> Member Since
                  </label>
                  <p className="text-gray-900 font-medium">
                    {user?.createdAt
                      ? new Date(user.createdAt).toLocaleDateString("en-IN", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      : "---"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Actions / Stats (Placeholder for future) */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
              <h2 className="text-lg font-bold text-gray-800 mb-4">
                Account Actions
              </h2>
              <div className="space-y-3">
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center justify-between p-3 text-left text-red-600 bg-red-50 hover:bg-red-100 rounded-xl transition-colors group"
                >
                  <span className="font-medium">Sign Out</span>
                  <FiLogOut className="transform group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <EditProfileModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        user={user}
        onSave={handleEditProfile}
      />
      <ChangePasswordModal
        isOpen={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
        onSave={handleChangePassword}
      />
    </div>
  );
};
